export class Mensagem {
  public static readonly FALHA_REQUISICAO = 'Falha na requisição.';

  public static readonly SEM_RESULTADO_EXPORTAR = 'Nenhum resultado encontrado para exportação !';

  public static readonly SUCESSO = 'Operação realizada com sucesso.';

  public static readonly DOWNLOAD_SUCESSO = 'Download realizado com sucesso.';

  public static readonly DOWNLOAD_EM_PROGRESSO = 'Download em progresso';

  public static readonly DOWNLOAD_MULTIPLOS = '$qtde arquivos sendo baixados';

  public static readonly ERRO = 'Erro no serviço.';

  public static readonly PREENCHA_TODOS_CAMPOS = 'Preencha todos os campos obrigatórios.';

  public static readonly DADOS_SERAO_PERDIDOS = 'Deseja realmente cancelar a operação? Todos os dados não salvos serão perdidos.';


  public static readonly MSG_A001 = 'Deseja realmente excluir este registro?';

  public static readonly MSG_S001 = 'Registro Cadastrado com sucesso.';
  public static readonly MSG_S002 = 'Registro alterado com sucesso.';
  public static readonly MSG_S003 = 'Registro excluído com sucesso.';
  public static readonly MSG_S004 = 'Solicitação de Invalidação de auto encaminhada com sucesso.';
  public static readonly MSG_S005 = 'Contribuição enviada com sucesso e registrada sob o protocolo <NumProtocolo>. Esta confirmação será encaminhada para o e-mail cadastrado. A ANTT agradece sua participação';

  public static readonly MSG_E001 = 'Nenhum registro encontrado.';
  public static readonly MSG_E002 = 'Este campo é obrigatório.';
  public static readonly MSG_E003 = 'Erro no serviço.';
  public static readonly MSG_E021 = 'O arquivo anexo deve ser de um dos tipos: jpg, jpeg, png, bmp, doc, xls, ppt, mpp, docx, xlsx, pptx, odt, ods, odp, pdf, txt, rtf, dwg, .rar, .zip e .7z.'
  public static readonly MSG_E048 = 'Tamanho máximo de 2GB excedido!';
  public static readonly MSG_E052 = 'É permitido no máximo 3 arquivos com no máximo 2GB cada.';
  public static readonly MSG_E055 = 'Pelo menos um campo deve ser preenchido para realizar a busca.';

  public static readonly TIPO_INVALIDO = (tipo: string) => `Apenas arquivos do(s) tipo(s) ${tipo} são aceitos.`;

  public static readonly TAMANHO_MAXIMO = (tamanho: string) => `Arquivos de no máximo ${tamanho} são aceitos.`;


  public static readonly MSG_CAMPO_INVALIDO = (
    variavelPrincipal: string,
    generoDaVariavel: string,
  ) => variavelPrincipal + ' inválido' + generoDaVariavel + '!';
}
